var swiperPartners = [].slice.call(document.querySelectorAll('.slider-partners__swiper'));
swiperPartners.forEach(function (el) {
  new Swiper(el, {
    centeredSlides: true,
    spaceBetween: 80,
    autoHeight: false,
    loop: true,
    grabCursor: true,
    navigation: {
      nextEl: ".slider-partners-next",
      prevEl: ".slider-partners-prev"
    },
    pagination: {
      el: ".slider-partners-pagination"
    },
    breakpoints: {
      1200: {
        autoHeight: true
      }
    }
  });
});
var swiperGallerySection = [].slice.call(document.querySelectorAll('.js-swiper-gallery-section'));
swiperGallerySection.forEach(function (sectionEl) {
  var swiperGalleryEl = sectionEl.querySelector('.js-swiper-gallery');
  var swiperGalleryThumbsEl = sectionEl.querySelector('.js-swiper-gallery-thumbs');
  var swiperGalleryThumbs = new Swiper(swiperGalleryThumbsEl, {
    spaceBetween: 10,
    slidesPerView: "auto",
    watchSlidesProgress: true,
    breakpoints: {
      1200: {
        direction: "vertical"
      }
    }
  });
  new Swiper(swiperGalleryEl, {
    spaceBetween: 20,
    autoHeight: false,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    thumbs: {
      swiper: swiperGalleryThumbs
    },
    breakpoints: {
      1200: {
        spaceBetween: 0,
        autoHeight: true
      }
    }
  });
});